const page = (title: string, path: string) => ({
  title,
  href: `https://docs.hatchet.run/${path}`,
});

export const docsPages = {
  v1: {
    events: page('Events', 'v1/events'),
    logging: page('Logging', 'v1/logging'),
    opentelemetry: page('OpenTelemetry', 'v1/opentelemetry'),
    quickstart: page('Quickstart', 'v1/quickstart'),
    webhooks: page('Webhooks', 'v1/webhooks'),
    workers: page('Workers', 'v1/workers'),
    'cron-runs': page('Cron Runs', 'v1/cron-runs'),
    'rate-limits': page('Rate Limits', 'v1/rate-limits'),
    'scheduled-runs': page('Scheduled Runs', 'v1/scheduled-runs'),
    security: {
      'audit-logs': page('Audit Logs', 'v1/security/audit-logs'),
    },
    'advanced-assignment': {
      'worker-affinity': page(
        'Worker Affinity',
        'v1/advanced-assignment/worker-affinity',
      ),
    },
  },
  'self-hosting': {
    'configuration-options': page(
      'Engine Configuration Options',
      'self-hosting/configuration-options',
    ),
  },
} as const;
